<div class="container">
  <div class="denied-container">
    <img src="./assets/shell/denied.svg" width="250" height="250" alt="" /> <br />
    <span class="denied-title">{{ 'general.error_403_title' | translate }}</span
    ><br />
    <span class="denied-text">{{ 'general.error_403_page_not_permissions' | translate }}</span>
    <br />
    <div class="denied-text">
      {{ 'general.error_403_page_go_to' | translate }}
      <a routerLink="/" class="denied-link">{{
        'general.error_403_page_home_page' | translate
      }}</a
      ><span class="denied-text">.</span>
    </div>
  </div>
</div>
